import {ParameterValues} from '@/model/api/parameters';
import {Parameters} from '@/model/offline/storage/ParameterStorage';

/**
 * Manages parameters that were not submitted yet
 */
export class NotSubmittedParameters {
    public static readonly STORAGE_KEY = 'notSubmittedParameters';

    constructor(private readonly parameters: Parameters) {
    }

    public add(parameterName: string, value: any): void {
        this.parameters.add(parameterName, value);
    }

    public get(): ParameterValues {
        return this.parameters.getAll();
    }

    public remove(parameterNames: string[]): void {
        this.parameters.remove(...parameterNames);
    }

    public clear(): void {
        this.parameters.removeAll();
    }
}
